
const floatMenuPlacerParent = $('.webinar-float-menu-parent');
const pageSections = $('.shopify-section').slice(3);
const menuPlacer = $('.webinar-float-menu-parent');
const floatMenuParent = floatMenuPlacerParent.find('.float-menu-parent');
const floatMenuInner = floatMenuParent.find('.float-menu-inner-container');
const floatMenuParentHeight = pxToVw(floatMenuParent.outerHeight());
let floatMenuTL;
let menuOutST;

const addDownloadBtnControl = () => {
    const downloadBtn = floatMenuPlacerParent.find('.float-menu-download-button-placer .button-parent');
    const downloadBtnTextOverflow = downloadBtn.find('.button-text-overflow');
    const downloadBtnText = downloadBtn.find('.button-text');
    const btnTextWidth = pxToVw(downloadBtnText.outerWidth());
    const floatMenuInnerWidth = pxToVw(floatMenuInner.width());

    gsap.set(downloadBtnTextOverflow, {width: 0});

    downloadBtn.off('mouseenter mouseleave click');

    downloadBtn.on('mouseenter', function () {
        gsap.to(
            downloadBtnTextOverflow, {
                width: `${btnTextWidth}vw`,
                duration: 0.53,
                ease: 'pageInEasing',
            }
        )
        gsap.to(
            downloadBtnText, {
                opacity: 1,
                duration: 0.43,
                delay: 0.3
            }
        )
    })
    downloadBtn.on('mouseleave click', function () {
        gsap.to(
            downloadBtnTextOverflow, {
                width: 0,
                duration: 0.53,
                ease: 'pageInEasing',
            }
        )
        gsap.to(
            downloadBtnText, {
                opacity: 0,
                duration: 0.43,
            }
        )
    })
}

const addFloatMenuAnimation = () => {
    if (menuOutST) menuOutST.kill();
    floatMenuTL = gsap.timeline({ paused: true, onComplete: () => {
        gsap.set(floatMenuInner, {
            clearProps: 'width',
        })
    }});
    const floatMenuOpacityItems = floatMenuInner.find('.float-menu-opacity-item');
    const floatSingMenuBtnParent = floatMenuParent.find('.float-menu-sign-button-placer .button-parent');
    const btnSingTextOverflow = floatSingMenuBtnParent.find('.button-text-overflow');
    const btnSingText = floatSingMenuBtnParent.find('.button-text');

    gsap.set([floatMenuInner, btnSingTextOverflow], {
        clearProps: 'width,height,transform',
        visibility: 'hidden',
        display: 'flex',
    });

    const floatMenuInnerWidth = pxToVw(floatMenuInner.width());
    const floatMenuInnerHeight = pxToVw(floatMenuInner.height());
    const textWidth = pxToVw(btnSingText.outerWidth());
    addBtnHover(floatSingMenuBtnParent);

    gsap.set([floatMenuInner, btnSingTextOverflow], {
      clearProps: 'all',
      visibility: 'visible',
    });

    floatMenuTL.add(
        gsap.fromTo(
            floatMenuParent, {
                opacity: 0,
                y: `${0.938 * 1.5 + floatMenuParentHeight}vw`,
            },{
                y: 0,
                opacity: 1,
                duration: 0.63,
                ease: 'pageInEasing',
            }
        ), 'step1'
    );
    floatMenuTL.add(
        gsap.fromTo(
            btnSingTextOverflow, {
                width: 0,
            },{
                width: `${textWidth}vw`,
                duration: 0.83,
                ease: 'pageInEasing',
            }
        ), 'step1+=0.48'
    );
    floatMenuTL.add(
        gsap.fromTo(
            floatMenuInner, {
                width: `${floatMenuInnerHeight}vw`,
                height: `${floatMenuInnerHeight}vw`,
            },{
                width: `${floatMenuInnerWidth}vw`,
                height: `${floatMenuInnerHeight}vw`,
                duration: 0.83,
                ease: 'pageInEasing',
            }
        ), 'step1+=0.48'
    );
    floatMenuTL.add(
        gsap.fromTo(
            floatMenuOpacityItems, {
                opacity: 0,
            },{
                opacity: 1,
                duration: 0.63,
                ease: 'pageInEasing',
            }
        ), 'step1+=0.68'
    );

    floatMenuTL.progress(1);

    menuOutST = ScrollTrigger.create({
        trigger: $('#webinar-form-section,#form-section .form-section-topper'),
        end: `top bottom`,
        onEnterBack: () => {
            floatMenuTL.play();
        },
        onLeave: () => {
            floatMenuTL.progress(1);
            floatMenuTL.reverse();
        },
    });
};

const setFloarMenuParent = () => {
    const webinarCover = $('.webinar-cover-parent');
    const webinarFormTopper = $('#webinar-form-section,#form-section .form-section-topper');
    const offsetTop = pxToVw(webinarCover.offset().top);
    const offsetEnd = pxToVw(webinarFormTopper.offset().top);
    const height = offsetEnd - offsetTop;
    gsap.set(floatMenuPlacerParent, {height: `${height}vw`, top: `${offsetTop}vw`});
}

$(window).on('deviceChange', function () {

});

$(window).on('load', () => {
    setFloarMenuParent();
    addDownloadBtnControl();
    addFloatMenuAnimation();
});